import React, { useState } from 'react';
import { Typography } from 'antd';
import { Flex } from 'antd/lib';
import { StatusCodes } from '@constants/enum/common';
import DataTable from '@components/dataTable/DataTable';
import ActionButtons from '@modules/Roles/components/ActionButtons/ActionButtons';
import { PRESET_ROLE_NAMES, ROLES_LIST, ROLES_PRESET_TAB } from '@modules/Roles/constants/roles';
import useRoles from '@modules/Roles/hooks/useRoles';
import { RBACRole } from '@modules/Roles/types/roles';
import styles from './PresetRoles.module.scss';
import PermissionsViewer from '../PermissionsViewer/PermissionsViewer';

const { Text } = Typography;

const PresetRoles: React.FC = () => {
  const { fetchRolesStatus, presetRoles, role, setCurrentRole } = useRoles();

  const [openPreview, setOpenPreview] = useState<boolean>(false);

  const onPreview = (record: RBACRole) => {
    setCurrentRole(record);
    setOpenPreview(true);
  };

  const tableColumns = [
    {
      title: ROLES_LIST.ROLE_LABEL,
      dataIndex: 'role_name',
      key: 'role_name',
      width: '30%',
      render: (value: keyof typeof PRESET_ROLE_NAMES) =>
        value in PRESET_ROLE_NAMES ? PRESET_ROLE_NAMES[value] : value,
    },
    {
      title: ROLES_LIST.DESCRIPTION_LABEL,
      dataIndex: 'description',
      key: 'description',
    },
    {
      key: 'action',
      width: '8%',
      render: (_: unknown, record: RBACRole) => {
        const { role_id: roleId } = record;
        return <ActionButtons roleId={roleId} onPreview={() => onPreview(record)} preset />;
      },
    },
  ];

  return (
    <Flex gap="middle" vertical>
      <Text className={styles.presetRolesTitle}>{ROLES_PRESET_TAB.title}</Text>
      <DataTable
        data={presetRoles}
        columns={tableColumns}
        total={0}
        rowSelectionAvailable={false}
        loading={fetchRolesStatus === StatusCodes.IN_PROGRESS}
        searchAvailable={false}
      />
      {openPreview && role && (
        <PermissionsViewer isOpen={openPreview} role={role} onClose={() => setOpenPreview(false)} />
      )}
    </Flex>
  );
};

export default PresetRoles;
